export const contactTextMessageLabel = 'Contact has opted to receive text messages';
